import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import BrokerCard from '../BrokerCard/BrokerCard';
import BannerCards from "../BannerCards/BannerCards";
import BrokerContactComponent from '../BrokerContactComponent/BrokerContactComponent';
import { DPASearchModule } from "DPA-Search-Reactjs";
import './BrokerBanner.css';

const BrokerBanner = ({ brokerData }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showDPAModal, setShowDPAModal] = useState(false);

  // Format phone number from 951.536.2288 to (951)536-2288 for display
  // and +19515362288 for href
  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return { display: '', href: '' };

    // Remove all non-numeric characters
    const numericOnly = phoneNumber.replace(/\D/g, '');

    // Format for display - assumes 10 digit US number
    let displayNumber = phoneNumber;
    if (numericOnly.length === 10) {
      displayNumber = `(${numericOnly.substring(0, 3)})${" "}${numericOnly.substring(3, 6)}-${numericOnly.substring(6)}`;
    }

    // Format for href
    const hrefNumber = `+1${numericOnly}`;

    return { display: displayNumber, href: hrefNumber };
  };

  // Extract angel AI name from URL
  const extractAngelAIName = (url) => {
    if (!url) return '';

    // Extract the name after the last slash
    const parts = url.split('/');
    return parts[parts.length - 1] || '';
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Determine which video to use based on screen width
  const videoSource = windowWidth > 992
    ? `${process.env.REACT_APP_CDN || ''}brokers-landingpages-resources/images/desktopvideo.mp4`
    : `${process.env.REACT_APP_CDN || ''}brokers-landingpages-resources/images/mobilevideo.mp4`;

  // Handle contact modal open/close
  const handleOpenContactModal = () => setShowContactModal(true);
  const handleCloseContactModal = () => setShowContactModal(false);

  // Handle DPA modal open/close
  const handleOpenDPAModal = () => setShowDPAModal(true);
  const handleCloseDPAModal = () => setShowDPAModal(false);

  // Create URL for calculator button
  const angelAIName = extractAngelAIName(brokerData?.angelaiUrl || '');
  const calculatorUrl = `https://www.swmc.com/angelai/${angelAIName}/Welcome_Calculators?opts=w`;

  // Format phone number
  const phoneNumber = formatPhoneNumber(brokerData?.direct);

  // Check if brokerData exists before rendering
  if (!brokerData) {
    return <div>Loading...</div>;
  }

  return (
    <section>
      <div className="broker-banner-wrapper">
        {/* Video Background with Overlay */}
        <div className="video-background">
          <video autoPlay muted loop playsInline className="banner-video">
            <source src={videoSource} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="video-overlay"></div>
        </div>
        <Container className="banner-container">
          <Row className="align-items-center">
            {/* Left content area */}
            <Col lg={7} className="banner-left-content">
              <h1 className="banner-title">
                <span className="text-white">Mortgage</span><br />
                <span className="text-primary">Loan Originator</span>
              </h1>
              <h2 className="banner-subtitle text-white">Work With a Trusted Mortgage Partner</h2>
            </Col>
            {/* Right content area - Broker Card Component */}
            <Col lg={5} className="banner-right-content">
              <BrokerCard brokerData={brokerData} showContactInfo={false} />
            </Col>
          </Row>
          <Col xl={7} lg={7} md={12} className="banner-left-buttons">
            <div className="banner-buttons">
              <Button
                variant="danger"
                className="apply-now-btn"
                onClick={handleOpenContactModal}
              >
                Apply Now
              </Button>
              <Button
                variant="dark"
                className="find-dpa-btn"
                onClick={handleOpenDPAModal}
              >
                Find My DPA
              </Button>
              <Button
                variant="dark"
                className="calculator-btn"
                href={calculatorUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Loan Calculator
              </Button>
              <Button
                variant="dark"
                className="phone-btn"
                href={`tel:${phoneNumber.href}`}
              >
                {phoneNumber.display}
              </Button>
            </div>
          </Col>
        </Container>
      </div>

      {/* Contact Form Modal */}
      <Modal
        show={showContactModal}
        onHide={handleCloseContactModal}
        size="lg"
        centered
        className="broker-contact-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className='Apply-now-modal-header'>Apply Now</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BrokerContactComponent brokerData={brokerData} />
        </Modal.Body>
      </Modal>

      {/* DPA Search Modal */}
      <Modal
        show={showDPAModal}
        onHide={handleCloseDPAModal}
        size="lg"
        centered
        className="dpa-search-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className='dpa-search-modal-header'>Down Payment Assistance Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DPASearchModule loanOfficerUid={brokerData.loID} />
        </Modal.Body>
      </Modal>

      <BannerCards />
    </section>
  );
};

export default BrokerBanner;